<ion-content style="background-color: transparent;">

  <div class="divMessage">
    <div>
      <p>{{optionPhoto.title}}</p>
    </div>
  </div>

  <!-- Preview Camera -->
  <div *ngIf="imageService.cameraActive" class="divCentral">
    <img class="image-overlay" alt="watch"
      [src]="'../../assets/icon/camera_preview/' + optionPhoto.frameToUse + '.png'" />
    <div id="cameraPreview" class="cameraPreview">
    </div>
  </div>

</ion-content>

<!-- Footer button -->
<ion-footer class="ion-no-border marginFooter transparente" style="background-color: transparent;">

  <div class="centerBtnCamera">
    <ion-item lines="none">
      <!-- Manter vazio -->
    </ion-item>
    <ion-item lines="none" (click)="imageService.touchTakePicture()" style="padding-left: 25px;">
      <img alt="watch" src="../../assets/icon/take_photo.svg" />
    </ion-item>
    <ion-item lines="none">
    </ion-item>
  </div>

</ion-footer>
